var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7698_9251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9364 3.46533L10.8904 6.51127C12.0963 6.70322 14.4043 5.43408 15.1545 4.68349C16.7453 3.09267 15.4185 1.23748 15.4185 1.23748C15.4185 1.23748 13.5633 -0.0893185 11.9725 1.5015C11.2223 2.25209 9.9528 4.55974 10.1448 5.7656L13.1907 2.71967L13.9364 3.46533Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80945 4.96934L7.85538 8.01527C8.04734 6.80977 6.77784 4.50176 6.02761 3.75152C4.43679 2.16035 2.58159 3.48715 2.58159 3.48715C2.58159 3.48715 1.2548 5.34234 2.84562 6.93352C3.5955 7.6834 5.90316 8.95289 7.10937 8.76094L4.06378 5.71535L4.80945 4.96934Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1328 14.2189C15.179 14.2217 14.1476 13.9894 13.2708 13.5559C12.0994 12.9821 10.826 12.6517 9.52733 12.5814V9.6096C9.52733 8.49093 9.96291 7.43871 10.7543 6.64734L10.8903 6.51129C10.684 6.47859 10.5096 6.40301 10.3813 6.27469C10.2529 6.14637 10.1774 5.97199 10.1447 5.76562L10.0086 5.90168C9.21444 6.69586 8.70608 7.70027 8.53627 8.78941C8.3735 8.56476 8.19139 8.35136 7.99135 8.15132L7.8553 8.01527C7.8226 8.22199 7.74702 8.39601 7.6187 8.52433C7.49038 8.65265 7.316 8.72859 7.10928 8.76093L7.24569 8.89734C8.03706 9.68835 8.47264 10.7406 8.47264 11.8592V12.581C7.16694 12.6524 5.87882 12.9916 4.72921 13.5559C3.87421 13.9778 2.84519 14.2228 1.86714 14.2189H0V15.9328H18V14.2189H16.1328Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.9874H18V18.7189H0V16.9874Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7698_9251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.718872)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheme);
export default __webpack_public_path__ + "static/media/scheme.8ff82f1cc105239b160d764b5aaf5733.svg";
export { ForwardRef as ReactComponent };